import axios from 'axios';
import ReferralRewardInterface from '@/apps/order/interfaces/ReferralRewardInterface';
import LinkedCustomFieldDefinitionInterface from '@/apps/order/interfaces/LinkedCustomFieldDefinitionInterface';

class ReferralRewardsAPI {
  static fetch(brandId: number): Promise<ReferralRewardInterface[]> {
    return new Promise((resolve, reject) => {
      // Skip when endpoint missing (e.g. io.center) -> avoid request to undefined.
      if (!window.API_URLS.referralRewards) {
        resolve([]);
        return;
      }
      axios.get<{
        rewards: {
          id: number
          label: string
          referrer: boolean
          customer: boolean
          customFields?: LinkedCustomFieldDefinitionInterface[]
        }[]
      }>(`${window.API_URLS.referralRewards}`, {
        params: {
          brand: brandId,
        },
      }).then((response) => {
        resolve((response.data?.rewards || []).map((reward) => ({
          value: `${reward.id}`,
          label: reward.label,
          referrer: reward.referrer,
          customer: reward.customer,
          ...(reward.customFields?.length ? { customFields: reward.customFields } : {}),
        })));
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default ReferralRewardsAPI;
